import { component } from "picoapp";
import { handleize } from "../lib/utils";
import { throttle } from "lodash-es";
import getProductJson from "../lib/getProductJson";

export default component(async (node, context) => {
  const [{ default: KeenSlider }] = await Promise.all([
    import("keen-slider"),
    import("keen-slider/keen-slider.min.css"),
  ]);

  const trigger = node.querySelector("[data-button]");
  const dropdown = node.querySelector("[data-dropdown]");
  const options = dropdown
    ? dropdown.querySelectorAll("input[type='radio'")
    : null;
  const selectedOption = node.querySelector("[data-selected]");
  const sliderElement = node.querySelector("[data-keen-slider]");
  const optionName = node.querySelector("[data-option-name]");
  let isOpen = node.classList.contains("open");
  const anchor = document.querySelector("[data-sticky-anchor]");
  const selectElement = node.querySelector("[data-select]");
  const bottom = node.classList.contains("bottom");
  const headerNav = document.querySelector("#shopify-section-tbsp-navigation");
  // carousel
  const slider = new KeenSlider(sliderElement, {
    drag: false,
    created: (slider) => {
      slider.container.classList.remove("hide-init");
    },
  });

  const handleCarousel = (variantId) => {
    const selectedSlide = slider.slides.find((slide) => {
      return slide.dataset.variantId === variantId;
    });
    if (!selectedSlide) return;
    const index = selectedSlide.dataset.index;
    slider.moveToIdx(parseInt(index));
  };

  // scroll events and positioning
  const handleScroll = () => {
    const scrollPosition =
      document.body.scrollTop || document.documentElement.scrollTop;
    const anchorPosition = anchor ? anchor.offsetTop : 0;

    if (scrollPosition > anchorPosition) {
      const headerNavHeight = headerNav.clientHeight;
      node.style.top = `${headerNavHeight}px`;
      node.style.pointerEvents = "auto";
      node.ariaHidden = "false";
      node.classList.add("is-visible");
      slider.update();
    } else {
      node.style.pointerEvents = "none";
      node.ariaHidden = "true";
      node.classList.remove("is-visible");
      resetPosition();
    }
  };

  const resetPosition = () => {
    if (bottom) {
      node.style.transform = "translateY(100%)";
    } else {
      // node.style.transform = 'translateY(-100%)'
    }
  };

  document.addEventListener("scroll", throttle(handleScroll, 50));

  // show/hide options list
  const handleTriggerClick = () => {
    if (isOpen) {
      closeOptions();
      trigger.focus();
    } else {
      openOptions();
      slider.update();
    }
  };

  const closeOptions = () => {
    trigger.setAttribute("aria-expanded", false);
    node.classList.remove("open");
    isOpen = false;
  };

  const openOptions = () => {
    trigger.setAttribute("aria-expanded", true);
    node.classList.add("open");
    isOpen = true;
  };

  const handleOutsideClick = (e) => {
    if (!node.contains(e.target) && isOpen) {
      closeOptions();
    }
  };

  // option click handlers
  const selectOption = async (option, appContext) => {
    const { currentVariant } = appContext.getState();
    if (currentVariant.id === parseInt(option.dataset.vid)) {
      return false;
    }

    unselectAllOptions();
    option.setAttribute("aria-selected", true);
    trigger.setAttribute("aria-activedescendant", option.getAttribute("id"));

    optionName.innerHTML = option.value;
    selectedOption.className = "";
    selectedOption.className = `bg-${handleize(option.value)}`;
    option.checked = true;
    selectElement.value = option.dataset.vid;
    handleCarousel(option.dataset.vid);
    const product = await getProductJson();
    const variant = product.variants.find(
      (v) => parseInt(v.id) === parseInt(option.dataset.vid)
    );

    window.dispatchEvent(
      new CustomEvent("variant-selected:id", {
        detail: {
          product: product.handle,
          variant: variant.id,
          options: product.options,
        },
      })
    );
  };

  const unselectAllOptions = () => {
    options.forEach((option) => {
      option.removeAttribute("aria-selected");
    });
  };

  // bind events
  node.addEventListener("click", handleOutsideClick);
  trigger.addEventListener("click", handleTriggerClick);
  if (options) {
    options.forEach((option) => {
      option.addEventListener("click", function (e) {
        selectOption(option, context);
      });
    });
  }

  // variant selected event listener
  window.addEventListener("variant-selected:id", async (event) => {
    const { variant } = event.detail;
    const selectedOption = [...options].find(
      (_option) => parseInt(_option.dataset.vid) === parseInt(variant)
    );
    if (!selectedOption) return false;
    selectOption(selectedOption, context);
  });

  context.on("product:update", (state) => {
    const quantityInput = node.querySelector('input[name="quantity"]');
    quantityInput.value = state.quantity;
  });
});
